import { Component } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackBarService } from '../../../_services/snackbar.service';
import { MultimediaService } from '../../../_services/comparador/multimedia.service';
import { ComparadorService } from '../../../_services/comparador/comparador.service';
import { Multimedia } from '../../../_models/comparador/multimedia';
import { MultimediaComponent } from '../../../comparador/components/multimedia/multimedia.component';
import { DialogService } from '../../../_services/dialog.service';
import { EtiquetasService } from '../../../_services/etiquetas.service';

@Component({
	selector: 'borrar-archivo-dialog',
	templateUrl: 'borrar-archivo.dialog.template.html',
	styleUrls: ['borrar-archivo.scss'],
})
export class BorrarArchivoDialog {
	constructor(
		public multimediaService: MultimediaService,
		public comparadorService: ComparadorService,
		public snackbarService: SnackBarService,
		public etiquetasService: EtiquetasService
	) {}

	archivo: Multimedia;
	snackBarRef: MatSnackBarRef<BorrarArchivoDialog>;
	multimediaComponent: MultimediaComponent;
	dialogService: DialogService;

	cancelar(): void {
		this.snackBarRef.dismiss();
	}

	deleteMultimedia(idMultimedia: number) {
		this.multimediaService.deleteMultimedia(idMultimedia).subscribe(
			(res) => {
				if (res.Succeed) {
					this.snackBarRef.dismiss();
					this.snackbarService.openSnackBar(
						true,
						this.etiquetasService.getEtiqueta('comparador', 'borrado'),
						this.etiquetasService.getEtiqueta('comparador', 'borradoCorrectamente'),
						false,
						2000
					);
				}
			},
			(error) => {
				this.snackBarRef.dismiss();
				this.snackbarService.openSnackBar(false, 'Error', error, false, 3000);
			},
			() => {
				this.snackBarRef.dismiss();
				this.multimediaComponent.getMultimediaByNodo(
					this.multimediaComponent.idNodoRef,
					this.multimediaComponent.profundidad
				);
			}
		);
	}
}
